import CommentItem from './CommentItem';

export default CommentItem;
